import styled, { css } from 'styled-components';
import { Space } from 'src/utils/theme';

export const Container = styled.ul<{ $containerHeight?: Space }>(
  ({ theme, $containerHeight }) => css`
    display: flex;
    flex-direction: column;
    max-height: ${$containerHeight ? theme.sz[$containerHeight] : '100%'};
    list-style: none;
    margin: 0;
    min-width: 100%;
    overflow-y: auto;
    padding: ${theme.sz.s2} ${theme.sz.s2} ${theme.sz.s4} ${theme.sz.s2};

    &::-webkit-scrollbar {
      width: ${theme.sz.s2};
    }

    &&::-webkit-scrollbar-thumb {
      background: ${theme.co.secondary60};
      border-radius: ${theme.sz.s1};
    }
  `,
);
